import { cn } from '../cn';

export function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]!.toUpperCase())
    .join('');
}

/** 26 px circle, track2 fill, mono 500 10px initials. */
export function Avatar({ name, className }: { name: string; className?: string }) {
  return (
    <div aria-hidden className={cn('grid h-[26px] w-[26px] flex-none place-items-center rounded-full bg-track2 font-mono text-xs font-medium text-fg', className)}>
      {initials(name)}
    </div>
  );
}
